import { Box, Radio } from "@mui/material";
import { colors, alphaVar } from "../../../../ui/colors";

type PaymentMethodItemProps = {
  selected: boolean;
  onToggle: () => void;
  children: React.ReactNode;
};

export const PaymentMethodItem = ({ selected, onToggle, children }: PaymentMethodItemProps) => {
  return (
    <Box
      role="checkbox"
      aria-checked={selected}
      tabIndex={0}
      onClick={onToggle}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onToggle();
        }
      }}
      sx={{
        display: "flex",
        alignContent: "center",
        justifyContent: "space-between",

        position: "relative",
        borderRadius: 2,
        outline: "none",
        border: `1px solid ${alphaVar(colors.gray[200], 0.5)}`,
        transition: "0.1s ease-in-out",

        "&:hover": {
          boxShadow: `0 0 0 2px ${alphaVar(colors.gray[300], 0.15)}`,
        },
        ...(selected && {
          borderColor: alphaVar(colors.orange.base, 0.9),
          boxShadow: `0 0 0 2px ${alphaVar(colors.orange.base, 0.15)}`,
        }),
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "fit-content",

          position: "absolute",
          top: 20,
          right: 8,
          zIndex: 1,
        }}
      >
        <Radio
          checked={selected}
          size="small"
          sx={{ "&.Mui-checked": { color: colors.orange[500] } }}
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
        />
      </Box>

      {children}
    </Box>
  );
};
